const features = [
  {
    icon: "⬛",
    h: "Dead Stock Detection",
    p: "Identifies products that haven't sold in 60+ days. Ranked by cash blocked so you know where to act first.",
  },
  {
    icon: "📉",
    h: "Slow-Mover Analysis",
    p: "Flags SKUs selling below healthy velocity. Catches problems before they become dead stock.",
  },
  {
    icon: "💰",
    h: "Cash Blocked in Inventory",
    p: "Calculates exactly how much money is sitting in unsold stock by category, brand, and product.",
  },
  {
    icon: "🚫",
    h: "Stop-Buying Recommendations",
    p: "Shows which products you should not reorder based on movement trends — before you make the next purchase.",
  },
  {
    icon: "📊",
    h: "SKU, Category & Brand Breakdown",
    p: "Drill into performance by any dimension. See which categories drag down your overall inventory health.",
  },
  {
    icon: "✅",
    h: "Simple Dashboard, Clear Actions",
    p: "No bloated analytics. Every insight comes with a clear action — clear, discount, stop buying, or hold.",
  },
];

export default function FeatureSection() {
  return (
    <div className="sm-section-full sm-section-bg" id="features">
      <div className="sm-section">
        <div className="sm-reveal">
          <span className="sm-eyebrow">Features</span>
          <h2 className="sm-h2">
            Everything your buying team
            <br />
            actually needs to know
          </h2>
          <p className="sm-h2-sub">
            No vanity metrics. No complex dashboards. Just the information that
            directly affects your cash flow and buying decisions.
          </p>
        </div>

        <div className="sm-features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`sm-feature-card sm-reveal sm-reveal-d${(index % 3) + 1}`}
            >
              <div className="sm-feature-icon">{feature.icon}</div>
              <h3 className="sm-feature-h3">{feature.h}</h3>
              <p className="sm-feature-p">{feature.p}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}